<div class="error-snack flex justify-start items-center gap-[24px]">
  <mat-icon class="red-600-fg">warning</mat-icon>
  <span>{{data}}</span>
  <button (click)="snackBarRef.dismiss()" mat-flat-button class="mat-button" color="primary"><span class="text-white">Ok</span></button>
</div>
